
export  class Globals{
    public static userconfig;
    public static version="1.1.7";
    static getUser():any{
        this.userconfig=JSON.parse(localStorage.getItem('userconfig'));
        return this.userconfig;
    }
    static isEdit():Boolean{
        this.userconfig=JSON.parse(localStorage.getItem('userconfig'));
        let roles= [];
        roles= this.userconfig.Roles.find(x=>x.Name=='Edit'||x.Name=='Admin');
        if(roles!=undefined||roles!=null)
            return true;
        else {
            return false;
        }
    }
    static isChangeCar():Boolean{
        this.userconfig=JSON.parse(localStorage.getItem('userconfig'));
        let roles= [];
        roles= this.userconfig.Roles.find(x=>x.Name=='Sa'||x.Name=='Sp');
        if(roles!=undefined||roles!=null)
            return true;
        else {
            
        return false;
    }
    }
    static isSp():Boolean{
        this.userconfig=JSON.parse(localStorage.getItem('userconfig'));
        let roles= [];
        roles= this.userconfig.Roles.find(x=>x.Name=='Sp');
        if(roles!=undefined||roles!=null)
            return true;
        else {  
            return false;
        }
    }
    static IsNotPermission():void{
        alert("Bạn Không Có Quyền!");
        location.reload();
    }
    static calculateDiff(to:string,from:string){
        let dateTo = new Date(to);
        let dateFrom = new Date(from);
        return Math.floor((Date.UTC(dateFrom.getFullYear(), dateFrom.getMonth(), dateFrom.getDate()) - Date.UTC(dateTo.getFullYear(), dateTo.getMonth(), dateTo.getDate()) ) /(1000 * 60 * 60 * 24));
       }
}
export class XmlSnippet {
    pending: boolean = false;
    status: string = 'init';
  
    constructor(public src: string, public file: File) {}
  }
export interface IPaging {
    page:number;
    perPage:number;
}
  
export class ImageSnippet {
    pending: boolean = false;
    status: string = 'init';
  
    constructor(public src: string, public file: File) { }
  }